export default __webpack_public_path__ + "static/player_data-a474739bc21acec3865c393e3085da29.svg";